/**
 * @classdesc Traditional Chinese Language Pack
 * @desc This class will used to translate tokens into the Traditional Chinese language.
 * @namespace Languages.TraditionalChinese
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.TraditionalChinese
 */
export const dictionary = {
	'years'   : '年',
	'months'  : '月',
	'days'    : '日',
	'hours'   : '時',
	'minutes' : '分',
	'seconds' : '秒'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.TraditionalChinese
 */
export const aliases = ['zh-tw'];
